<template>
  <el-dialog
    :visible.sync="visible"
    title="发票抬头管理"
    width="80%"
    @close="handleClose"
    v-loading="loading"
  >
    <div class="invoice-title-manage">
      <el-button type="primary" @click="handleAdd">新增</el-button>
      <div style="margin: 15px 0"></div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        height="500"
      >
        <el-table-column prop="title" label="发票抬头" width="180"></el-table-column>
        <el-table-column prop="tax_no" label="纳税人识别号" width="180"></el-table-column>
        <el-table-column prop="phone" label="联系电话"></el-table-column>
        <el-table-column prop="address" label="联系地址"></el-table-column>
        <el-table-column prop="bank" label="开户行"></el-table-column>
        <el-table-column prop="bank_account" label="开户行帐号"></el-table-column>
        <el-table-column prop="email" label="邮箱地址"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="total"
        style="margin-top: 15px"
      ></el-pagination>

    </div>

    <!-- 新增/编辑弹框 -->
    <el-dialog
      :title="dialogTitle" :modal="false"
      :visible.sync="dialogFormVisible"
      width="50%"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="发票抬头" prop="title">
          <el-input v-model="form.title" placeholder="请输入发票抬头"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号">
          <el-input v-model="form.tax_no" placeholder="请输入纳税人识别号"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="form.phone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="联系地址">
          <el-input v-model="form.address" placeholder="请输入联系地址"></el-input>
        </el-form-item>
        <el-form-item label="开户行">
          <el-input v-model="form.bank" placeholder="请输入开户行"></el-input>
        </el-form-item>
        <el-form-item label="开户行帐号">
          <el-input v-model="form.bank_account" placeholder="请输入开户行帐号"></el-input>
        </el-form-item>
        <el-form-item label="邮箱地址">
          <el-input v-model="form.email" placeholder="请输入邮箱地址"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  name: 'InvoiceTitleManage',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    pid : {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      dialogFormVisible: false,
      dialogTitle: '新增发票抬头',
      form: {
        pindex_id : this.pid,
        id: 0,
        title: '',
        tax_no: '',
        phone: '',
        address: '',
        bank: '',
        bank_account: '',
        email: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' }
        ]
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$myhttp.get(`admin/invoiceTitleList?pid=${this.pid}&page=${this.currentPage}&pageSize=${this.pageSize}`)
        .then(response => {
          if (response.data.code === 200) {
            this.tableData = response.data.data.list;
            this.total = response.data.data.total;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    handleAdd() {
      this.dialogTitle = '新增发票抬头';
      this.form = {
        pindex_id : this.pid,
        id: 0,
        title: '',
        tax_no: '',
        phone: '',
        address: '',
        bank: '',
        bank_account: '',
        email: ''
      };
      this.dialogFormVisible = true;
    },
    handleEdit(row) {
      this.dialogTitle = '编辑发票抬头';
      this.form = Object.assign({}, row);
      this.dialogFormVisible = true;
    },
    handleDelete(row) {
      this.$confirm('确认删除该发票抬头?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$myhttp.post('admin/deleteInvoiceTitle', { id: row.id })
          .then(response => {
            if (response.data.code === 200) {
              this.$message.success('删除成功');
              this.fetchData();
            }
          });
      });
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const url = this.form.id ? 'admin/updateInvoiceTitle' : 'admin/addInvoiceTitle';
          this.$myhttp.post(url, this.form)
            .then(response => {
              if (response.data.code === 200) {
                this.$message.success('操作成功');
                this.dialogFormVisible = false;
                this.fetchData();
              }else{
                this.$message.error(response.data.msg);
              }
            });
        }
      });
    },
    handleClose() {
      this.$emit('close', false);
    }
  },
  watch: {
    visible(n, o) {
      if (n === true) {
        this.currentPage = 1;
        this.fetchData();
      }
    },
  },
};
</script>

<style scoped>
.invoice-title-manage {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Finance/invoiceTitleManage.vue